<template>

  <div class="test-elements-container">

    <transition name="fade">

      <div v-show="ifTrue" class="test-elements test-elements_true"></div>

    </transition>

    <transition name="fade">

      <div v-show="ifTrue === false" class="test-elements test-elements_false"></div>

    </transition>

  </div>


</template>

<script>

export default {

  name: 'TestElements',

  props: ['ifTrue']

}

</script>

<style lang="sass" scoped>

.test-elements
  width: 698.44px
  height: 318.5px

  &-container
    position: absolute
    height: 100vh
    display: flex
    flex-direction: column
    justify-content: center

  &_true
    background-image: url(../assets/img/elements_true.png)

  &_false
    background-image: url(../assets/img/elements_false.png)

@media (max-width: 420px)

  .test-elements
    width: 72.5vw
    height: 72vw

    &-container
      height: 100%

    &_true
      background-image: url(../assets/img/elements_true_m.svg)

    &_false
      width: 69vw
      height: 105vw
      top: calc(50% - 56vw)
      background-image: url(../assets/img/elements_false_m.svg)

</style>
